import React, { useEffect } from 'react';
import { Heading } from '../components/Heading/Heading';
import Banner from '../components/Banner/Banner';
import { Button } from '../components/Button/Button';
import { Text } from '../components/Text/Text';
import { Container } from '../components/Container/Container';
import { AnimatedContainer } from '../components/AnimatedContainer/AnimatedContainer';
import bannerImage from '../assets/banner.jpg';
import LogoHorizontalWhite from '../assets/logo-horizontal-white.svg';
import LogoVerticalWhite from '../assets/logo-vertical-white.svg';
import image1 from '../assets/image1.jpg';
import image3 from '../assets/image3.jpg';
import image4 from '../assets/image4.png';
import image5 from '../assets/image5.png';
import image6 from '../assets/image6.png';
import image7 from '../assets/image7.png';
import ContentWithImage from '../components/ContentWithImage/ContentWithImage';
import LogoSlider from '../components/LogoSlider/LogoSlider';
import { useMediaQuery } from 'react-responsive';

const HomePage: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div>
      <Banner imageUrl={bannerImage} isGrayscale isFullHeight>
        <div className="flex flex-col items-center justify-center max-w-[900px] m-auto px-4">
          <img src={LogoHorizontalWhite} alt="" width={900} className="hidden md:block" />
          <div className="md:hidden px-6 flex flex-col items-center justify-center">
            <img src={LogoVerticalWhite} alt="" width={400} />
            <Text size="xl" className="text-center pt-6 text-gray-200">
              Thought Leadership and Executive Coaching
            </Text>
          </div>
        </div>
      </Banner>

      <AnimatedContainer animationType="slideUp" delay={200}>
        <Container contentClassName="py-16 flex-col" hasPadding>
          <Heading intent="h4" className="text-center">
            Schedule a meeting
          </Heading>
          <Text size="xl" className="text-center">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </Text>
          <Button
            className="self-center mt-8"
            intent="primary"
            textAlign="center"
            href={'/schedule-appointment'}
          >
            Schedule a Meeting
          </Button>
        </Container>
      </AnimatedContainer>

      <AnimatedContainer animationType="slideUp" delay={300}>
        <Container contentClassName="gap-4 py-16 text-center" hasPadding>
          <ContentWithImage imageUrl={image1} imagePosition="left">
            <div className="flex flex-col py-8 md:py-16">
              <Heading intent="h4" padding="noPadding" className="pb-4">
                About me
              </Heading>
              <Text size="base">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur
                magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit
              </Text>
              <Text size="base" className="pt-4">
                sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam
                quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam
                corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem
                vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae
                consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
              </Text>
            </div>
          </ContentWithImage>
        </Container>
      </AnimatedContainer>

      <AnimatedContainer animationType="fadeIn" delay={200}>
        <LogoSlider />
      </AnimatedContainer>

      <AnimatedContainer animationType={isMobile ? 'slideUp' : 'slideRight'} delay={300}>
        <Container contentClassName="gap-4 py-6 md:py-8 lg:py-16 text-center" hasPadding>
          <ContentWithImage
            imageUrl={bannerImage}
            imagePosition="right"
            borderPosition="right"
            isGrayscale
          >
            <div className="flex flex-col py-8 md:py-16">
              <Heading intent="h4" padding="noPadding" className="pb-4">
                Executive Coaching
              </Heading>
              <Text size="base">
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis
                praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias
                excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui
                officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem
                rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est
                eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere
                possimus.
              </Text>
              <Text size="base" className="pt-4">
                Omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et
                aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates
                repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a
                sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut
                perferendis doloribus asperiores repellat.
              </Text>
            </div>
          </ContentWithImage>
        </Container>
      </AnimatedContainer>

      <AnimatedContainer animationType={isMobile ? 'slideUp' : 'slideLeft'} delay={300}>
        <Container contentClassName="gap-4 py-6 md:py-8 lg:py-16 text-center" hasPadding>
          <ContentWithImage
            imageUrl={image4}
            imagePosition="left"
            borderPosition="left"
            isGrayscale
          >
            <div className="flex flex-col py-8 md:py-16">
              <Heading intent="h4" padding="noPadding" className="pb-4">
                Board Consulting & Advisory
              </Heading>
              <Text size="base">
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis
                praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias
                excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui
                officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem
                rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est
                eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere
                possimus.
              </Text>
              <Text size="base" className="pt-4">
                Omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et
                aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates
                repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a
                sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut
                perferendis doloribus asperiores repellat.
              </Text>
            </div>
          </ContentWithImage>
        </Container>
      </AnimatedContainer>

      <AnimatedContainer animationType={isMobile ? 'slideUp' : 'slideRight'} delay={300}>
        <Container contentClassName="gap-4 py-6 md:py-8 lg:py-16 text-center" hasPadding>
          <ContentWithImage
            imageUrl={image3}
            imagePosition="right"
            borderPosition="right"
            isGrayscale
          >
            <div className="flex flex-col py-8 md:py-16">
              <Heading intent="h4" padding="noPadding" className="pb-4">
                Speaking Engagement
              </Heading>
              <Text size="base">
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis
                praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias
                excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui
                officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem
                rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est
                eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere
                possimus.
              </Text>
              <Text size="base" className="pt-4">
                Omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et
                aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates
                repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a
                sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut
                perferendis doloribus asperiores repellat.
              </Text>
            </div>
          </ContentWithImage>
        </Container>
      </AnimatedContainer>

      <AnimatedContainer animationType={isMobile ? 'slideUp' : 'slideLeft'} delay={300}>
        <Container contentClassName="gap-4 py-6 md:py-8 lg:py-16 text-center" hasPadding>
          <ContentWithImage
            imageUrl={image5}
            imagePosition="left"
            borderPosition="left"
            isGrayscale
          >
            <div className="flex flex-col py-8 md:py-16">
              <Heading intent="h4" padding="noPadding" className="pb-4">
                Master Classes
              </Heading>
              <Text size="base">
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis
                praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias
                excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui
                officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem
                rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est
                eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere
                possimus.
              </Text>
              <Text size="base" className="pt-4">
                Omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et
                aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates
                repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a
                sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut
                perferendis doloribus asperiores repellat.
              </Text>
            </div>
          </ContentWithImage>
        </Container>
      </AnimatedContainer>

      <AnimatedContainer animationType={isMobile ? 'slideUp' : 'slideRight'} delay={300}>
        <Container contentClassName="gap-4 py-6 md:py-8 lg:py-16 text-center" hasPadding>
          <ContentWithImage
            imageUrl={image7}
            imagePosition="right"
            borderPosition="right"
            isGrayscale
          >
            <div className="flex flex-col py-8 md:py-16">
              <Heading intent="h4" padding="noPadding" className="pb-4">
                Online Course
              </Heading>
              <Text size="base">
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis
                praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias
                excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui
                officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem
                rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est
                eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere
                possimus.
              </Text>
              <Text size="base" className="pt-4">
                Omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et
                aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates
                repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a
                sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut
                perferendis doloribus asperiores repellat.
              </Text>
              <div>
                <Button
                  className="mt-6"
                  intent="primary"
                  textAlign="center"
                  href={'/online-course'}
                >
                  Go to course
                </Button>
              </div>
            </div>
          </ContentWithImage>
        </Container>
      </AnimatedContainer>

      <Banner imageUrl={image6}>
        <div className="flex flex-col items-center justify-center max-w-[900px] m-auto px-4 py-20">
          <Heading intent="h2" className="text-white text-center">
            Schedule a meeting
          </Heading>
          <Text size="xl" className="text-white text-center">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </Text>
          <Button
            className="self-center mt-8"
            intent="primary"
            textAlign="center"
            href={'/schedule-appointment'}
          >
            Schedule a Meeting
          </Button>
        </div>
      </Banner>

      <AnimatedContainer animationType="slideUp" delay={200}>
        <Container contentClassName="py-16 flex-col" hasPadding>
          <Heading intent="h4" className="text-center">
            Magnam aliquam quaerat
          </Heading>
          <Text size="xl" className="text-center">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </Text>
        </Container>
      </AnimatedContainer>

      <AnimatedContainer animationType="slideUp" delay={300}>
        <Container contentClassName="gap-4 py-16 text-center" hasPadding>
          <ContentWithImage imageUrl={bannerImage} imagePosition="left" isGrayscale>
            <div className="flex flex-col py-8 md:py-16">
              <Heading intent="h4" padding="noPadding" className="pb-4">
                Nemo enim ipsam voluptatem
              </Heading>
              <Text size="base">
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium
                doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur
                magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est,
                qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit
              </Text>
              <Text size="base" className="pt-4">
                sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam
                quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam
                corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem
                vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae
                consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
              </Text>
            </div>
          </ContentWithImage>
        </Container>
      </AnimatedContainer>
    </div>
  );
};

export default HomePage;
